import { Button, Sprite, _decorator } from 'cc';
import LocalizedAsset from './LocalizedAsset';

const { ccclass, menu, property } = _decorator;

@ccclass
@menu('Internationalization/LocalizedButton')
export default class LocalizedButton extends LocalizedAsset<Button> {
    @property
    private readonly keyPattern: string = '{0}-{1}';

    public reset() {
        this.target.normalSprite = null;
        this.target.pressedSprite = null;
        this.target.hoverSprite = null;
        this.target.disabledSprite = null;
        this.target.target.getComponent(Sprite).spriteFrame = null;
    }

    protected onKeyChange(): void {
        this.i18n.getButtonSpriteFrameSet(this.key, this.keyPattern)?.apply(this.target);
    }

    protected getTarget(): Button {
        return this.getComponent(Button);
    }
}
